<!-- Favorites Modal Overlay -->
<div class="favorite-overlay" (click)="close()">
  <div class="favorite-modal" (click)="$event.stopPropagation()">
    <!-- Blocking overlay: prevents any interaction while a write is in progress -->
    <div class="blocking-overlay" *ngIf="isBlocking">
      <div class="spinner"></div>
      <span>{{ blockingMessage }}</span>
    </div>
    <!-- Header -->
    <div class="modal-header">
      <h3>Favorites</h3>
      <button class="close-btn" (click)="close()">
        <span class="material-icons-outlined">close</span>
      </button>
    </div>

    <!-- Loading spinner -->
    <div class="loading-bar" *ngIf="loading">
      <div class="spinner"></div>
      <span>Loading favorites...</span>
    </div>

    <!-- Table -->
    <div class="modal-body" *ngIf="!loading">
      <table class="favorites-table">
        <thead>
          <tr>
            <th class="col-sno">S.No</th>
            <th
              class="col-name"
              [attr.aria-sort]="nameSortDirection === 'asc' ? 'ascending' : 'descending'">
              <button
                type="button"
                class="sort-btn"
                (click)="toggleNameSort()"
                [title]="nameSortDirection === 'asc' ? 'Sort names descending' : 'Sort names ascending'">
                <span>Favorite Name</span>
                <span class="material-icons-outlined" aria-hidden="true">
                  {{ nameSortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </button>
            </th>
            <th class="col-action">Import</th>
            <th class="col-action">Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let slot of displayedSlots; let rowIndex = index" [class.row-loading]="isRowLoading(slot)">
            <td class="col-sno">{{ rowIndex + 1 }}</td>
            <td class="col-name">
              <!-- Inline edit mode -->
              <div class="name-cell" *ngIf="editingSlot === slot.slno">
                <input
                  type="text"
                  class="inline-edit-input"
                  [ngModel]="editValue"
                  (ngModelChange)="onRenameChange($event)"
                  (keyup.enter)="confirmInlineEdit()"
                  (keyup.escape)="cancelInlineEdit()" />
                <button class="inline-btn confirm-btn" (click)="confirmInlineEdit()" [disabled]="!editValue.trim()" title="Confirm">
                  <span class="material-icons-outlined">check</span>
                </button>
                <button class="inline-btn cancel-inline-btn" (click)="cancelInlineEdit()" title="Cancel">
                  <span class="material-icons-outlined">close</span>
                </button>
              </div>
              <!-- Normal display mode -->
              <div class="name-cell" *ngIf="editingSlot !== slot.slno">
                <a *ngIf="slot.shareableLink && isSlotOccupied(slot)"
                   [href]="slot.shareableLink"
                   target="_blank"
                   class="fav-name-link">{{ slot.UIName }}</a>
                <span *ngIf="!slot.shareableLink && isSlotOccupied(slot)">{{ slot.UIName }}</span>
                <span *ngIf="!isSlotOccupied(slot)" class="empty-slot">—</span>
                <button
                  *ngIf="isSlotOccupied(slot)"
                  class="inline-btn edit-inline-btn"
                  [disabled]="isRowLoading(slot)"
                  (click)="startInlineEdit(slot)"
                  title="Rename">
                  <span class="material-icons-outlined">edit</span>
                </button>
                <button
                  *ngIf="isSlotOccupied(slot) && slot.shareableLink"
                  class="inline-btn copy-inline-btn"
                  [disabled]="isRowLoading(slot)"
                  (click)="copyShareLink(slot)"
                  title="Copy share link">
                  <span class="material-icons-outlined">content_copy</span>
                </button>
              </div>
            </td>
            <td class="col-action">
              <button
                class="action-btn import-btn"
                [disabled]="!isSlotOccupied(slot) || isRowLoading(slot)"
                (click)="onImport(slot)"
                title="Import this favorite">
                <span class="material-icons-outlined">publish</span>
              </button>
            </td>
            <td class="col-action">
              <button
                class="action-btn delete-btn"
                [disabled]="!isSlotOccupied(slot) || isRowLoading(slot)"
                (click)="onDelete(slot)"
                title="Delete this favorite">
                <span class="material-icons-outlined">delete</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Delete Confirmation Dialog -->
<div class="sub-overlay" *ngIf="deleteDialogVisible" (click)="onCancelDelete()">
  <div class="sub-dialog" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="dialog-close"
      aria-label="Close"
      (click)="onCancelDelete()">&times;</button>
    <h4>Delete Favorite</h4>
    <p>Are you sure you want to delete this favorite?</p>
    <div class="dialog-actions">
      <button class="btn-confirm btn-danger" (click)="onConfirmDelete()">Yes, delete</button>
    </div>
  </div>
</div>

<!-- Rename Overwrite Confirmation Dialog -->
<div class="sub-overlay" *ngIf="renameConfirmVisible" (click)="cancelRenameOverwrite()">
  <div class="sub-dialog" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="dialog-close"
      aria-label="Close"
      (click)="cancelRenameOverwrite()">&times;</button>
    <h4>Overwrite Favorite</h4>
    <p>A favorite named "{{ pendingRename?.newName }}" already exists. Overwrite it?</p>
    <div class="dialog-actions">
      <button class="btn-confirm" (click)="confirmRenameOverwrite()">Overwrite</button>
    </div>
  </div>
</div>

<!-- Toast -->
<div class="toast" [class.visible]="toastVisible">
  {{ toastMessage }}
</div>
